// (C) Copyright 2016-2025 Hewlett Packard Enterprise Development LP
export const isOnPrem = () => {
  return process.env.PLATFORM === 'on-prem';
};

export const constructActiveMemberId = (id, property) => {
  if (!isOnPrem()) return id;
  if (!property) return id;
  return `${id}_PROP_${property}`;
};

export const deconstructActiveMemberId = (string, onlyId, onlyProperty) => {
  const parts = string?.split('_PROP_') || [];
  const id = parts?.[0];
  const property = parts?.[1];
  if (onlyId) return id;
  if (onlyProperty) return property;
  return string;
};

export const checkActiveMemberIdHasProperty = (string) => {
  const parts = string.split('_PROP_');
  return parts?.length > 1;
};
